import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BrandService } from 'app/core/services/brand.service';

/**
 * Topbar Component - Angular 19
 * Barra superior com logo, notificações e menu de usuário
 */
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TopbarComponent {
  private brandService = inject(BrandService);

  brandConfig = this.brandService.config;
}
